import { render, staticRenderFns } from "./gameplayTypeOptions.vue?vue&type=template&id=0e087580&"
import script from "./gameplayTypeOptions.vue?vue&type=script&lang=js&"
export * from "./gameplayTypeOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e087580')) {
      api.createRecord('0e087580', component.options)
    } else {
      api.reload('0e087580', component.options)
    }
    module.hot.accept("./gameplayTypeOptions.vue?vue&type=template&id=0e087580&", function () {
      api.rerender('0e087580', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serverList/gameplayTypeOptions.vue"
export default component.exports